import * as Yup from "yup";

export const SignUpSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  // ema: Yup.string()
  //   .min(2, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string()
    .min(7, "Password must be atleast 8 characters.")
    .required("Required"),
  // confirmPassword: Yup.string()
  //   .min(7, "Password must be atleast 8 characters.")
  //   .required("Required")
  //   .oneOf([Yup.ref("password"), null], "Passwords must match"),
  role: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  // phoneNumber: Yup.number().required("Required"),
});
